import {showErrorMessage} from "@/helper";

export default {
    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/intermediaries/persons' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/intermediaries/persons/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecordsOfIntermediary(intermediaryId, body) {
        return new Promise((resolve, reject) => {
            http.post('api/intermediaries/' + intermediaryId + '/persons/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getIntermediaryPerson(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/intermediaries/persons/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject(error);
            });
        });
    },

    getOfIntermediary(intermediaryId, style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/intermediaries/' + intermediaryId + '/persons' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response?.data?.message) {
                    showErrorMessage(error.response.data.message);
                }
                reject({ persons: [], visible_fields: [] });
            });
        });
    },

    saveIntermediaryPerson(data, intermediaryId) {
        return new Promise((resolve, reject) => {
            http.post('api/intermediaries/' + intermediaryId + '/persons' + (data.id ? '/' + data.id : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response.data.message) {
                    showErrorMessage(error.response.data.message);
                } else {
                    reject([]);
                }
            });
        });
    },

    deleteIntermediaryPerson(intermediaryPersonId) {
        return new Promise((resolve, reject) => {
            http.delete('api/intermediaries/persons/' + intermediaryPersonId).then(response => {
                resolve(response.data);
            }).catch(error => {
                showErrorMessage(error.response.data.message);
                //reject([]);
            });
        });
    },
}